/**
 *
 * Section About
 *
 */
import PropTypes from "prop-types";

function About(props) {
  return (
    <div className="row">
      <div className="col">
        <div className="step" id="about">
          <div
            className="buttonClose"
            onClick={(e) => props.emitChangeSection("closeSection", e)}
          >
            &nbsp;
          </div>
          <div><h1>I am am h1</h1><p>h1 p1 text</p><p>h1 p2 text</p><h1>I am a h2</h1><p>h2 p1  text</p><p>h2 p2  text</p><p>h2 p3  text</p><h1>I am a h3</h1><p>h2 p1  text</p></div>
        </div>
      </div>
    </div>
  );
}

About.propTypes = {
  emitChangeSection: PropTypes.func, // Change step
};
export default About;
